








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { Patient } from '../../models/Patient';
import { RxTransfer, RxTransferContents, transferStatus } from '../../models/RxTransfer';
import { DatePicker } from 'element-ui'
import { Note, EntityType } from '@/models/Note';
import NotesList from '@/components/Note/NotesList.vue'
import moment from 'moment'
import { Prescription } from '../../models/Prescription';
import { TIInterchange, InterchangeNote } from '@/models/TIPartnerPharmacy'

@Component({
    name: "InterchangeDetailsModalComponent",
    components: {
        [DatePicker.name]: DatePicker,
        NotesList
    }
})

export default class InterchangeDetailsModalComponent extends Vue {
    @Prop() patient!: Patient;
    @Prop() interchangeId!: number;

    private interchange: TIInterchange = {} as TIInterchange;
    private interchangeNotes: InterchangeNote[] = [];
    private newNote: string = "";

    created() {
        this.getInterchangeDetails(this.interchangeId);
    }

    getInterchangeDetails(interchangeId: number) {
        axios.get(`/TIPortal/${interchangeId}/GetById`)
            .then(response => {
                this.interchange = response.data;
            });
        axios.get(`/TIPortal/${interchangeId}/GetNotes`)
            .then(response => {
                this.interchangeNotes = response.data;
            })
    }

    formatDate(d: Date): string {
        if (!d) return "";
        return moment.utc(d).local().format("L");
    }
}
